const TEACHER_AUTH = "TEACHER_AUTH";
const ADMIN_AUTH = "ADMIN_AUTH";
const STUDENT_AUTH = "STUDENT_AUTH";
const STATUSES = "STATUSES";

export { TEACHER_AUTH, ADMIN_AUTH, STUDENT_AUTH, STATUSES };
